import { render, staticRenderFns } from "./CmsMenuSettingShow.vue?vue&type=template&id=704da961&"
import script from "./CmsMenuSettingShow.vue?vue&type=script&lang=js&"
export * from "./CmsMenuSettingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports